<template>
  <article v-if="pointer.length > 0" class="c-article">
    <div
      v-for="item in pointer"
      :key="item.index"
      class="block pb-6 font-rubik"
    >
      <d-anchor :name="item.index" :shift="64" :text="item.name"/>
    </div>
  </article>
</template>

<script>
import DAnchor from 'dcode/components/DAnchor'
import { useStore } from 'vuex'
import { computed } from 'vue'

export default {
  name: 'CArticle',
  components: {
    DAnchor
  },
  setup () {
    const store = useStore()
    return {
      pointer: computed(() => store.getters.getPointer)
    }
  }
}
</script>

<style lang="scss"/>
